import { useStaticQuery, graphql } from 'gatsby'

export const useRecentPosts = () => {
  const { recentBlogs, recentVideos } = useStaticQuery(recentPostsQuery)
  const list = [...recentBlogs.nodes, ...recentVideos.nodes]
  return list || null
}

const recentPostsQuery = graphql`
  query allRecentArticleQuery(
    $includeTimeToRead: Boolean! = true
    $imageQuality: Int! = 75
  ) {
    recentBlogs: allBlog(sort: { fields: [date], order: DESC }) {
      nodes {
        ...BlogInformation
      }
    }

    recentVideos: allVideo(sort: { fields: [date], order: DESC }) {
      nodes {
        ...VideoInformation
      }
    }
  }
`
